import { store } from "@src/redux/store";
import { setLicenseLocked } from "@src/redux/license";

// Any 402 means the license is locked.
export const flagLicenseIfLocked = (error) => {
  if (error?.response?.status === 402 && !store.getState().license?.isLocked) {
    store.dispatch(setLicenseLocked(true));
  }
};
